/**
 * Brazilian Portuguese translations
 */

export default {
  'Enter your email': 'Digite seu e-mail',
  'Not included': 'Não incluído',
  'Pause video': 'Pausar vídeo',
  'Play video': 'Reproduzir vídeo',
  'Pricing plans': 'Planos de preços',
  'Select an option': 'Selecione uma opção',
  'Sign up for GitHub': 'Crie uma conta no GitHub',
  Country: 'País',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    'Você tem o direito de recusar a coleta e o uso de suas informações pessoais, o uso de informações pessoais para fins de marketing e o recebimento de informações de marketing conforme estabelecido acima. No entanto, se recusar, talvez não possa receber os benefícios descritos em Propósito de Coleta e Uso.',
  'I agree to the collection and use of my personal information (required)*.':
    'Concordo com a coleta e o uso de minhas informações pessoais (obrigatório)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    'Itens de informações pessoais a serem coletados: {fields}, e quaisquer outros campos visíveis neste formulário.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    'Finalidade da coleta e uso: o GitHub usará os dados para a finalidade descrita neste formulário.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    'Período de retenção/uso das informações pessoais: enquanto necessário para fornecer o(s) serviço(s) solicitado(s).',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'Concordo em receber informações de marketing e permitir o uso de minhas informações pessoais para fins de marketing (opcional).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'Consentimento para receber marketing: as informações coletadas podem ser usadas pelo GitHub para comunicações personalizadas, publicidade direcionada e eficácia de campanhas.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    'Finalidade da coleta e uso: entrar em contato com você para fins de marketing.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    'Período de retenção/uso das informações pessoais: enquanto necessário para fornecer o(s) serviço(s) solicitado(s).',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'Sim, quero que o GitHub e suas empresas afiliadas usem minhas informações para promover comunicação personalizada, publicidade direcionada e campanhas efetivas. Consulte a',
  'for more details.': 'para ver mais detalhes.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    'A participação exige a transferência de seus dados pessoais para outros países nos quais o GitHub opera, incluindo os Estados Unidos. Ao enviar este formulário, você concorda com a transferência de seus dados para fora da China.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    'Receberei comunicações personalizadas e publicidade direcionada do GitHub e afiliados. Veja o',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Sim, gostaria de receber informações do GitHub e seu grupo de empresas por e-mail para comunicações personalizadas, publicidade direcionada e eficácia de campanhas. Para retirar o consentimento ou gerenciar suas preferências de contato, visite o',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Sim, gostaria de receber informações do GitHub e seu grupo de empresas por e-mail e telefone para comunicações personalizadas, publicidade direcionada e eficácia de campanhas. Para retirar o consentimento ou gerenciar suas preferências de contato, visite o',
  'Promotional Communications Manager': 'Gerente de Comunicações Promocionais',
  'GitHub Privacy Statement': 'Declaração de privacidade do GitHub',
  'first name': 'nome',
  'last name': 'sobrenome',
  company: 'empresa',
  email: 'email',
  'This field is required.': 'Este campo é obrigatório.',
  'Please enter a valid work email address.': 'Por favor, insira um endereço de e-mail corporativo válido.',
  'The email is from a personal email provider.': 'O e-mail é de um provedor pessoal.',
  'Please enter a valid email address.': 'Por favor, insira um endereço de e-mail válido.',
  'Please enter a valid phone number.': 'Por favor, insira um número de telefone válido.',
  'Please select your country/region': 'Por favor, selecione seu país/região.',
  'Please complete the CAPTCHA.': 'Por favor, complete o CAPTCHA.',
  'Choose your country/region': 'Escolha seu país/região.',
  Included: 'Incluído',
  Refresh: 'Atualizar',
  Unlimited: 'Ilimitado',
  'Learn more': 'Saiba mais',
  'Sort by:': 'Ordenar por:',
  'Selecting a sort option will reload the page.': 'Selecionar uma opção de ordenação irá recarregar a página.',
  'Sort options': 'Opções de ordenação',
  Sort: 'Ordenar',
  Newest: 'Mais recente',
  Oldest: 'Mais antigo',
  Whitepaper: 'Artigo técnico',
  Ebook: 'E-book',
  Whitepapers: 'Artigos técnicos',
  Ebooks: 'E-books',
  AI: 'AI',
  Cloud: 'Nuvem',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'Uso de recursos internos',
  'Open Source': 'Código aberto',
  Security: 'Segurança',
  'Software Development': 'Desenvolvimento de Software',
  'Explore other resources': 'Veja outros recursos',
  Share: 'Compartilhar',
  'Ebooks & Whitepapers': 'E-books e artigos técnicos',
  Tags: 'Tags',
  Platform: 'Plataforma',
  'AI CODE CREATION': 'CRIAÇÃO DE CÓDIGO COM IA',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'Melhore o seu código com IA',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'Crie e implante aplicações inteligentes',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'Gerenciar e comparar prompts',
  'MCP Registry (New)': 'Registro de MCP (novo)',
  'Integrate external tools': 'Integre ferramentas externas',
  'View all features': 'Veja todos os recursos',
  'DEVELOPER WORKFLOWS': 'FLUXOS DE TRABALHO DO DESENVOLVEDOR',
  Actions: 'GitHub Actions',
  'Automate any workflow': 'Automatize qualquer fluxo de trabalho',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'Ambientes de desenvolvimento em um piscar de olhos',
  Issues: 'GitHub Issues',
  'Plan and track work': 'Planeje e monitore o trabalho',
  'Code review': 'Code Review',
  'Manage code changes': 'Gerencie mudanças de código',
  'APPLICATION SECURITY': 'SEGURANÇA DA APLICAÇÃO',
  'Find and fix vulnerabilities': 'Descubra e corrija vulnerabilidades',
  'Code Security': 'Code Security',
  'Secure your code as you build': 'Proteja seu código durante a compilação',
  'Secret Protection': 'Secret Protection',
  'Stop leaks before they start': 'Impeça vazamentos antes que aconteçam',
  EXPLORE: 'EXPLORAR',
  'Why GitHub': 'Por que o GitHub',
  Documentation: 'Documentação',
  Blog: 'Blog',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'Soluções',
  'BY COMPANY SIZE': 'POR PORTE EMPRESARIAL',
  Enterprises: 'Enterprises',
  'Small and medium teams': 'Equipes de pequeno e médio porte',
  Startups: 'Startups',
  Nonprofits: 'Organizações sem fins lucrativos',
  'View all solutions': 'Ver todas as soluções',
  'BY USE CASE': 'POR CASO DE USO',
  'App modernization': 'Modernização de aplicações',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'Ver todos os casos de uso',
  'BY INDUSTRY': 'POR INDÚSTRIA',
  Healthcare: 'Saúde',
  'Financial services': 'Serviços financeiros',
  Manufacturing: 'Manufatura',
  Government: 'Governo',
  'View all industries': 'Ver todos os setores',
  Resources: 'Recursos',
  'EXPLORE BY TOPIC': 'EXPLORAR POR ASSUNTO',
  'Software development': 'Desenvolvimento de software',
  'View all topics': 'Ver todos os tópicos',
  'EXPLORE BY TYPE': 'EXPLORAR POR TIPO',
  'Customer stories': 'Histórias de clientes',
  'Events & webinars': 'Eventos e webinars',
  'Ebooks & reports': 'Ebooks e relatórios',
  'Business insights': 'Insights de negócios',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'SUPORTE E SERVIÇOS',
  'Customer support': 'Atendimento ao cliente',
  'Community forum': 'Fórum da comunidade',
  'Trust Center': 'Trust Center',
  Partners: 'Parceiros',
  COMMUNITY: 'COMUNIDADE',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'Financiar desenvolvedores de código aberto',
  'The ReadME Project': 'O projeto ReadME',
  'GitHub community articles': 'Artigos da GitHub Community',
  'COMMUNITY PROGRAMS': 'PROGRAMAS DA COMUNIDADE',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'Comunidade de mantenedores',
  Accelerator: 'Acelerador',
  'Archive Program': 'Programa de arquivos',
  REPOSITORIES: 'REPOSITÓRIOS',
  Topics: 'Assuntos',
  Trending: 'Em alta',
  Collections: 'Coleções',
  Enterprise: 'Enterprise',
  'ENTERPRISE SOLUTIONS': 'SOLUÇÕES EMPRESARIAIS',
  'Enterprise platform': 'Plataforma empresarial',
  'AI-powered developer platform': 'Plataforma de IA para desenvolvedores',
  'AVAILABLE ADD-ONS': 'COMPLEMENTOS DISPONÍVEIS',
  'Enterprise-grade application security': 'Segurança da aplicação de nível empresarial',
  'Copilot for Business': 'Copilot para empresas',
  'Enterprise-grade AI features': 'Recursos de IA de nível empresarial',
  'Premium Support': 'Suporte Premium',
  'Enterprise-grade 24/7 support': 'Suporte 24/7 de nível empresarial',
  New: 'Novo',
  Select: 'Selecione',
  'Install with script': 'Instale com script',
  'Install with npm': 'Instale com npm',
  'Install with Homebrew': 'Instale com o Homebrew',
  'Install with WinGet': 'Instale com o WinGet',
  Copy: 'Copiar',
  'Copy installation command': 'Copiar comando de instalação',
  'Copied to clipboard': 'Copiado para a área de transferência',
  'Select install method': 'Selecione o método de instalação',
  'Get Copilot CLI': 'Obtenha o Copilot CLI',
  'Read the documentation.': 'Leia a documentação.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Incluído em assinaturas Copilot Free, Pro, Pro+, Business e Enterprise.',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'Incluído em assinaturas Copilot Free, Pro, Pro+, Max, Business e Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Disponível no Copilot Free, Pro, Pro+, Business e Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'Disponível no Copilot Free, Pro, Pro+, Max, Business e Enterprise.',
  'View all resources': 'Ver todos os recursos',
  'Enterprise-grade security features': 'Recursos de segurança de nível empresarial',
  Pricing: 'Preços',
  'Select country for phone number. Currently selected:': 'Selecione o país para o número de telefone. Seleção atual:',
  'Search countries': 'Pesquisar países',
  'Search countries...': 'Pesquisar países...',
  Countries: 'Países',
  'No countries found': 'Nenhum país encontrado',
  '{count} result available': '{count} resultado disponível',
  '{count} results available': '{count} resultados disponíveis',
  // Add more translations here
}
